/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// import { Manager, Target, Popper } from "react-popper";
import { NavLink, withRouter } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Hidden from "@material-ui/core/Hidden";
import Popper from "@material-ui/core/Popper";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";


// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import LockOpen from "@material-ui/icons/LockOpen";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import Notifications from "@material-ui/icons/Notifications";
import Person from "@material-ui/icons/Person";
// import Search from "@material-ui/icons/Search";

// core components
// import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import adminNavbarLinksStyle from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.jsx";
import authNavbarStyle from "assets/jss/material-dashboard-pro-react/components/authNavbarStyle.jsx";

// import LogoutButton from "components/CustomButtons/LogoutButton";
import { withFirebase } from 'contexts/Firebase';
import { compose } from 'redux';
import { USER_PROFILE_PAGE } from "constants/routes";
import { NOTIFICATION_TYPE } from "constants/notification";
import { ROLES } from "constants/user";
import { getDashboard } from "helpers/routes";


class HeaderLinks extends React.Component {
  state = {
    openNotification: false,
    openProfile: false
  };

  handleClickDashboard = () => {
    const { currentRole = {} } = this.props;
    const { role = ROLES.PERSONAL_USER } = currentRole;
    this.props.history.push(getDashboard(role));
  };
  handleClickNotification = () => {
    this.setState({ openNotification: !this.state.openNotification });
  };
  handleCloseNotification = () => {
    this.setState({ openNotification: false });
  };
  handleSelectNotification = (notification) => {
    return this.props.checkReadNotificationAction(notification.id)
      .then(() => {
        switch (notification.data().type) {
          case NOTIFICATION_TYPE.GENERAL_NOTICE:
            this.props.history.push("/admin/notices");
            break;
          case NOTIFICATION_TYPE.MESSAGE:
            this.props.history.push("/admin/messages");
            break;
          case NOTIFICATION_TYPE.ORG_REVIEW:
            this.props.history.push("/admin/orgs");
            break;
          case NOTIFICATION_TYPE.USER_REVIEW:
            this.props.history.push("/admins/users");
            break;
          case NOTIFICATION_TYPE.FORM:
            this.props.history.push("/admin/members")
            break;
          case NOTIFICATION_TYPE.PAYMENT:
            this.props.history.push("/admin/user-page");
            break;
          default:
          //do nothing
        }
        this.setState({ openNotification: false })
      });
  }
  handleClickProfile = () => {
    this.setState({ openProfile: !this.state.openProfile });
  };
  handleCloseProfile = () => {
    this.setState({ openProfile: false });
  };
  render() {
    const { classes, rtlActive, notifications = [] } = this.props;
    const { openNotification, openProfile } = this.state;
    const newNoficications = notifications.filter(noti => !noti.data().read_at);
    // const searchButton =
    //   classes.top +
    //   " " +
    //   classes.searchButton +
    //   " " +
    //   classNames({
    //     [classes.searchRTL]: rtlActive
    //   });
    const dropdownItem = classNames(
      classes.dropdownItem,
      classes.primaryHover,
      { [classes.dropdownItemRTL]: rtlActive }
    );
    const dropdownBottomMenuItem = classNames(
      classes.dropdownItem,
      classes.dropdownItemInfoColor,
      classes.infoHover,
    );
    const wrapper = classNames({
      [classes.wrapperRTL]: rtlActive
    });
    const managerClasses = classNames({
      [classes.managerClasses]: true
    });
    return (
      <div className={wrapper}>
        {/* <CustomInput
          rtlActive={rtlActive}
          formControlProps={{
            className: classes.top + " " + classes.search
          }}
          inputProps={{
            placeholder: rtlActive ? "بحث" : "Search",
            inputProps: {
              "aria-label": rtlActive ? "بحث" : "Search",
              className: classes.searchInput
            }
          }}
        />
        <Button
          color="white"
          aria-label="edit"
          justIcon
          round
          className={searchButton}
        >
          <Search
            className={classes.headerLinksSvg + " " + classes.searchIcon}
          />
        </Button> */}
        <Button
          color="transparent"
          simple
          aria-label="Dashboard"
          justIcon
          className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
          muiClasses={{
            label: rtlActive ? classes.labelRTL : ""
          }}
          onClick={this.handleClickDashboard}
        >
          <Dashboard
            className={
              classes.headerLinksSvg +
              " " +
              (rtlActive
                ? classes.links + " " + classes.linksRTL
                : classes.links)
            }
          />
          <Hidden mdUp implementation="css">
            <span className={classes.linkText}>
              {rtlActive ? "لوحة القيادة" : "통계데이터"}
            </span>
          </Hidden>
        </Button>
        <div className={managerClasses}>
          <Button
            color="transparent"
            justIcon
            aria-label="Notifications"
            aria-owns={openNotification ? "notification-menu-list" : null}
            aria-haspopup="true"
            onClick={this.handleClickNotification}
            className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
            muiClasses={{
              label: rtlActive ? classes.labelRTL : ""
            }}
            buttonRef={node => {
              this.anchorNotification = node;
            }}
          >
            <Notifications
              className={
                classes.headerLinksSvg +
                " " +
                (rtlActive
                  ? classes.links + " " + classes.linksRTL
                  : classes.links)
              }
            />
            {
              newNoficications.length > 0
                ? <span className={classes.notifications}>{newNoficications.length}</span>
                : null
            }
            <Hidden mdUp implementation="css">
              <span
                onClick={this.handleClickNotification}
                className={classes.linkText}
              >
                {rtlActive ? "إعلام" : "알림"}
              </span>
            </Hidden>
          </Button>
          <Popper
            open={openNotification}
            anchorEl={this.anchorNotification}
            transition
            disablePortal
            placement="bottom"
            className={classNames({
              [classes.popperClose]: !openNotification,
              [classes.popperResponsive]: true,
              [classes.popperNav]: true
            })}
          >
            {({ TransitionProps }) => (
              <Grow
                {...TransitionProps}
                id="notification-menu-list"
                style={{ transformOrigin: "0 0 0" }}
              >
                <Paper className={classes.dropdown}>
                  <ClickAwayListener onClickAway={this.handleCloseNotification}>
                    <MenuList role="menu">
                      {
                        notifications.length > 0
                          ? notifications.map((notification, index) => {
                            return (
                              <MenuItem
                                key={index}
                                onClick={() => this.handleSelectNotification(notification)}
                                className={dropdownItem}
                              >
                                {notification.data().content}
                              </MenuItem>
                            );
                          })
                          : <MenuItem
                            onClick={this.handleCloseNotification}
                            className={dropdownItem}
                          >
                            도착한 메시지가 없습니다.
                          </MenuItem>
                      }
                      <MenuItem
                        onClick={() => this.props.checkReadAllNotificationsAction().then(() => this.handleCloseNotification())}
                        className={dropdownBottomMenuItem}>
                        모두읽음으로 표시
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>

        <div className={managerClasses}>
          <Button
            color="transparent"
            aria-label="Person"
            justIcon
            aria-owns={openNotification ? "profile-menu-list" : null}
            aria-haspopup="true"
            onClick={this.handleClickProfile}
            className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
            muiClasses={{
              label: rtlActive ? classes.labelRTL : ""
            }}
            buttonRef={node => {
              this.anchorProfile = node;
            }}
          >
            <Person
              className={
                classes.headerLinksSvg +
                " " +
                (rtlActive
                  ? classes.links + " " + classes.linksRTL
                  : classes.links)
              }
            />
            <Hidden mdUp implementation="css">
              <span
                onClick={this.handleClickProfile}
                className={classes.linkText}
              >
                {rtlActive ? "الملف الشخصي" : "프로필"}
              </span>
            </Hidden>
          </Button>
          <Popper
            open={openProfile}
            anchorEl={this.anchorProfile}
            transition
            disablePortal
            placement="bottom"
            className={classNames({
              [classes.popperClose]: !openProfile,
              [classes.popperResponsive]: true,
              [classes.popperNav]: true
            })}
          >
            {({ TransitionProps }) => (
              <Grow
                {...TransitionProps}
                id="profile-menu-list"
                style={{ transformOrigin: "0 0 0" }}
              >
                <Paper className={classes.dropdown}>
                  <ClickAwayListener onClickAway={this.handleCloseProfile}>
                    <MenuList role="menu">
                      <NavLink
                        to={USER_PROFILE_PAGE}
                      // className={
                      //   classes.itemLink + " " + classes.userCollapseLinks
                      // }
                      >

                        <MenuItem
                          onClick={this.handleCloseProfile}
                          className={dropdownItem}
                        >
                          {rtlActive ? "الملف الشخصي" : "내 정보 관리"}
                        </MenuItem>
                      </NavLink>
                      {/* <MenuItem
                        onClick={this.handleCloseProfile}
                        className={dropdownItem}
                      >
                        {rtlActive ? "الإعدادات" : "Settings"}
                      </MenuItem> */}
                      <Divider light />
                      <MenuItem
                        onClick={this.props.firebase.doSignOut}
                        className={dropdownItem}
                      >
                        로그아웃
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool
};

export default compose(
  withStyles(adminNavbarLinksStyle),
  // withStyles(authNavbarStyle),
  withRouter,
  withFirebase
)(HeaderLinks);
